/** Exchange health tab: RMM snapshot slug and BRBEXCHANGE visibility. */

export const EXCHANGE_HEALTH_SLUG = 'exchange-health-status'

export const EXCHANGE_HOSTNAMES = ['brbexchange']

export const EXCHANGE_TAB_DESCRIPTION =
  'Microsoft Exchange Server health from the Bekat Toolkit Exchange Health Check script (services, databases, IIS, certificates, and transaction logs).'

export function exchangeHealthSnapshotFromRmmData(data) {
  return (data?.snapshots ?? []).find((s) => s.script_slug === EXCHANGE_HEALTH_SLUG) ?? null
}

export function showExchangeTabForAgent(agent, rmmData) {
  const hostname = (agent?.hostname || '').toLowerCase()
  if (EXCHANGE_HOSTNAMES.includes(hostname)) {
    return true
  }
  return Boolean(exchangeHealthSnapshotFromRmmData(rmmData))
}

export function transactionLogSeriesFromPayload(payload) {
  const rows = payload?.transaction_logs
  if (!Array.isArray(rows)) return []
  return rows.filter((row) => Array.isArray(row?.logs_by_day) && row.logs_by_day.length > 0)
}

export function formatExchangeLogDayLabel(dateText) {
  if (!dateText) return '—'
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateText))
  if (!match) return String(dateText)
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ]
  const month = months[Number(match[2]) - 1] || match[2]
  return `${Number(match[3])} ${month}`
}

export function groupExchangeChecks(checks) {
  const rows = checks ?? []
  const groups = {
    services: { title: 'Exchange services', items: [] },
    iis: { title: 'IIS and client access', items: [] },
    databases: { title: 'Mailbox databases', items: [] },
    logs: { title: 'Transaction logs and backup', items: [] },
    certificates: { title: 'Certificates and events', items: [] },
    other: { title: 'Other checks', items: [] },
  }

  for (const check of rows) {
    const area = String(check.area || check.check || '').toLowerCase()
    if (
      area.includes('service')
      || area.includes('failover')
      || area.includes('exchange server role')
      || area.includes('exchange version')
      || area.includes('exchange roles')
      || area.includes('exchange install')
    ) {
      groups.services.items.push(check)
    } else if (
      area.includes('iis')
      || area.includes('website')
      || area.includes('w3svc')
      || area.includes('was')
    ) {
      groups.iis.items.push(check)
    } else if (
      area.includes('database')
      || area.includes('mailbox database')
      || area.includes('database volume')
    ) {
      groups.databases.items.push(check)
    } else if (
      area.includes('log')
      || area.includes('backup')
      || area.includes('truncation')
    ) {
      groups.logs.items.push(check)
    } else if (
      area.includes('certificate')
      || area.includes('event')
      || area.includes('management shell')
    ) {
      groups.certificates.items.push(check)
    } else {
      groups.other.items.push(check)
    }
  }

  return Object.values(groups).filter((group) => group.items.length > 0)
}
